import { Injectable } from '@angular/core';

import { Observable } from 'rxjs/Observable';
import { ConfigService } from '../../../../core/services/config.service';
import { RequestService } from '../../../../core/services/request.service';

import { EmployeeDetails } from './details/employee-details.model';

@Injectable()
export class EmployeeService {

    constructor(
        private configService: ConfigService,
        private requestService: RequestService
    ) { }

    delete(details: any): Observable<EmployeeDetails> {
        let url = this.configService.get('server').url + this.configService.get('endpoints').agora.employees.delete.api;
        return this.requestService.post(url, details);
    }

    add(details: any): Observable<any> {
        let url = this.configService.get('server').url + this.configService.get('endpoints').agora.employees.adminAdd.api;
        return this.requestService.post(url, details);
    }

    edit(details: any): Observable<any> {
        let url = this.configService.get('server').url + this.configService.get('endpoints').agora.employees.edit.api;
        return this.requestService.post(url, details);
    }

    activate(details: any): Observable<any> {
        let url = this.configService.get('server').url + this.configService.get('endpoints').agora.employees.activate.api;
        return this.requestService.post(url, details);
    }

    deactivate(details: any): Observable<any> {
        let url = this.configService.get('server').url + this.configService.get('endpoints').agora.employees.deactivate.api;
        return this.requestService.post(url, details);
    }

    invite(details: any): Observable<any> {
        let url = this.configService.get('server').url + this.configService.get('endpoints').agora.employees.invite.api;
        return this.requestService.post(url, details);
    }

    getDepartments(): Observable<any> {
        let url = this.configService.get('server').url + this.configService.get('endpoints').agora.dictionary.department.api;
        return this.requestService.get(url);
    }

    getRoles(): Observable<any> {
        let url = this.configService.get('server').url + this.configService.get('endpoints').agora.dictionary.role.api;
        return this.requestService.get(url);
    }

    getDomains(params: any): Observable<any> {
        let url = this.configService.get('server').url + this.configService.get('endpoints').agora.dictionary.domain.api;
        return this.requestService.get(url, params);
    }

    getFields() {
        let fields= [
        {
            key: 'id',
            label: 'ID',
            type: 'hidden',
            required: false
        }, {
            key: 'domain',
            label: 'Domain',
            type: 'combobox',
            maxSelectedOptions: '1',
            required: true,
            dictionaryUrl:
                this.configService.get('server').url + this.configService.get('endpoints').agora.dictionary.domain.api
        }, {
            key: 'email',
            label: 'E-mail',
            type: 'textbox',
            pattern: 'email',
            trim: true,
            required: true
        }, {
            key: 'firstName',
            label: 'First Name',
            type: 'textbox',
            required: true
        }, {
            key: 'lastName',
            label: 'Last Name',
            type: 'textbox',
            required: true
        }, {
            key: 'department.id',
            label: 'Department',
            type: 'dropdown',
            required: false,
            dictionaryUrl:
                this.configService.get('server').url + this.configService.get('endpoints').agora.dictionary.department.api
        }, {
            key: 'roles',
            label: 'Roles',
            type: 'multi-dropdown',
            required: false,
            dictionaryUrl:
                this.configService.get('server').url + this.configService.get('endpoints').agora.dictionary.role.api
        }
        ];
        return fields;
    }

    getEmployeeDetails(id: string): Observable<any> {
        let url = this.configService.get('server').url + this.configService.get('endpoints').agora.employees.details.api + '/' + id;
        return this.requestService.get(url);
    }

    getDetailsFields() {
        let fields = [
            {
                key: (data: any) => {
                    if (data['domains'] && data['domains'][0]) {
                        return [data['domains'][0].name];
                    } else {
                        return [''];
                    }
                },
                label: 'Domain',
                type: 'list'
            }, {
              key: 'employeeId',
              label: 'Employee ID',
              type: 'text'
            }, {
              key: 'firstName',
              label: 'First Name',
              type: 'text'
            }, {
              key: 'lastName',
              label: 'Last Name',
              type: 'text'
            }, {
              key: 'email',
              label: 'E-mail',
              type: 'text'
            }, {
              key: 'department.configValue',
              label: 'Department',
              type: 'text'
            }, {
                key: 'roles',
                label: 'Roles',
                getter: (item) => {
                    return item.configValue;
                },
                type: 'list'
            }, {
                key: 'active',
                label: 'Is Active',
                type: 'boolean'
            }, {
                key: 'phoneNumbers',
                label: 'Phone Numbers',
                type: 'table',
                config: [
                    {
                        title: 'Type',
                        getter: (item) => {
                            return item.type.configValue;
                        }
                    }, {
                        title: 'Number',
                        name: 'number'
                    }, {
                        title: 'Primary',
                        name: 'primary',
                        type: 'map',
                        map: {
                            true: 'Yes',
                            false: 'No'
                        }
                    }
                ]
            }
        ];
        return fields;
    }
    getEditFields() {
        let fields= [
            {
                key: 'id',
                label: 'ID',
                type: 'hidden',
                required: false
            }, {
                key: 'employeeId',
                label: 'Employee ID',
                type: 'hidden',
                required: true
            }, {
                key: 'email',
                label: 'E-mail',
                type: 'text'
            }, {
                key: 'firstName',
                label: 'First Name',
                type: 'textbox',
                required: true
            }, {
                key: 'lastName',
                label: 'Last Name',
                type: 'textbox',
                required: true
            }, {
                key: 'department.id',
                label: 'Department',
                type: 'dropdown',
                required: false,
                dictionaryUrl:
                    this.configService.get('server').url + this.configService.get('endpoints').agora.dictionary.department.api
            }, {
                key: 'roles',
                label: 'Roles',
                type: 'multi-dropdown',
                required: false,
                dictionaryUrl:
                    this.configService.get('server').url + this.configService.get('endpoints').agora.dictionary.role.api
            }, {
                key: 'active',
                label: 'Active',
                type: 'radio',
                required: false,
                options: [
                    {key: true,  value: 'Yes'},
                    {key: false,  value: 'No'}
                ],
                default: false
            }
        ];
        return fields;
    }
}



// WEBPACK FOOTER //
// ./src/app/agora/components/account-data/employees/employee.service.ts